// extracted by mini-css-extract-plugin
export default {"date":"EntityCell_date__Opwqo","icon":"EntityCell_icon__fcWCe"};